<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-what-to-bring-detail
      [whatToBring]="whatToBring"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedWhatToBring)="onSavedWhatToBring($event)"
      (canceledWhatToBring)="onCanceledWhatToBring()"
    ></app-what-to-bring-detail>
  </div>
</div>
